import { render, staticRenderFns } from "./BCOptionalFeaturesToneAudioAudioVolume.vue?vue&type=template&id=9dc5c448"
import script from "./BCOptionalFeaturesToneAudioAudioVolume.vue?vue&type=script&lang=js"
export * from "./BCOptionalFeaturesToneAudioAudioVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports